import RoadshowsTile from './RoadshowsTile';
import RoadshowsTileWithFallback from './RoadshowsTileWithFallback';

export { RoadshowsTile, RoadshowsTileWithFallback };
export default RoadshowsTile;
